// extracted by mini-css-extract-plugin
export default {"dataContainer":"HiringDetails_dataContainer__4ElN7"};